/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { TestimonialHighlightComponentEditor } from "cms/components/components/testimonial-highlight/edit";
import { TestimonialHighlightComponentDisplay } from "cms/components/components/testimonial-highlight/display";
import { getComponentZoneLayout } from "cms/components/components/component";

const TestimonialHighlightComponent = (props) => {

    const zoneProps = {
        ...props,
        displayComponent: <TestimonialHighlightComponentDisplay />,
        editComponent: <TestimonialHighlightComponentEditor />,
    };
    return getComponentZoneLayout(zoneProps);
};

TestimonialHighlightComponent.displayName = "TestimonialHighlightComponent";
export { TestimonialHighlightComponent };
